import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Submissions from "./pages/Submissions";
import NavBar from "./components/NavBar.js";
import SubmissionFormPage from "./pages/SubmissionFormPage";
import Tracker from "./pages/Tracker";
import Login from "./pages/Login";
import About from "./pages/About";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import "./App.css";
import { isDevMode } from "./utils/utils.js";
import { Analytics } from "@vercel/analytics/react";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="app-container">
          {/* {isDevMode() && (
            <div className="dev-banner">
              <span className="dev-banner-heading">
                Welcome to dev mode! 🎉
              </span>
              <br />
              All production data will be replaced with mock data.
            </div>
          )} */}

          <NavBar />

          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/submissions"
                element={
                  <ProtectedRoute adminRequired={true}>
                    <Submissions />
                  </ProtectedRoute>
                }
              />
              <Route path="/submit" element={<SubmissionFormPage />} />
              <Route path="/tracker" element={<Tracker />} />
            </Routes>
          </main>

          <footer className="site-footer">
            <div className="footer-content">
              <p>&copy; {new Date().getFullYear()} Short Cuts NYC</p>
            </div>
          </footer>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
